import moment from "moment";
import callApi from "../../Api";
import { ToastMessage, ERROR } from "../../common/ToastMessage";
export const OPEN_LOADER = "OPEN_LOADER";
export const CLOSE_LOADER = "CLOSE_LOADER";
export const REPORTS = "REPORTS"
export const PENDING_PAYMENTS_DATA = "PENDING_PAYMENTS_DATA";
export const RESET_PAYMENTS_DATA = "RESET_PAYMENTS_DATA"

export const openLoader = (data) => ({
  type: OPEN_LOADER,
  payload: true,
});
export const closeLoader = (data) => ({
  type: CLOSE_LOADER,
  payload: false,
});

const formatPendingPayments = (data) => {
  data.filter(pendingPayments => {
    pendingPayments.regNo = pendingPayments?.Student?.RegNo ? pendingPayments?.Student?.RegNo : "- - -";
    pendingPayments.name = ((pendingPayments?.Student?.User?.firstName + " "+ pendingPayments?.Student?.User?.lastName) || ' - - -');
    pendingPayments.branch = pendingPayments?.Student?.Branch?.name || '- - -';
    pendingPayments.orderId = pendingPayments?.ORDER_ID || '- - -';
    pendingPayments.amount = pendingPayments?.amount || '- - -';
    pendingPayments.paymentMode = pendingPayments?.PaymentMode?.name || '- - -';
    pendingPayments.transactionNumber = pendingPayments?.ChequeTransaction?.chequeNumber || '- - -';
    pendingPayments.chequeIssueDate =  moment(pendingPayments?.ChequeTransaction?.chequeIssueDate).format("YYYY-MM-DD HH:MM:SS a")  || '- - -';
    pendingPayments.chequeExpiryDate = moment(pendingPayments?.ChequeTransaction?.chequeExpiryDate).format("YYYY-MM-DD HH:MM:SS a") || '- - -';
    pendingPayments.nameOfBank = pendingPayments?.ChequeTransaction?.nameOfBank || '- - -';
    pendingPayments.accountHolderName = pendingPayments?.ChequeTransaction?.accountHolderName || '- - -';
    pendingPayments.accountNumber = pendingPayments?.ChequeTransaction?.accountNumber || '- - -';
    pendingPayments.paidOn = moment(pendingPayments?.createdDate).format("YYYY-MM-DD HH:MM:SS a") || '- - -'
  })

  return data;
};

export const getPendingPayments = (params) => async (dispatch) => {
    try {
      dispatch(openLoader());
      const data = await callApi.get(`payments/pendingPayments?page=${params.page}&perPage=${params.perPage}`); // api

      const rows = formatPendingPayments(data.data.data.rows);

      if (data.data.success) {
        dispatch(closeLoader());
        dispatch({
          type: PENDING_PAYMENTS_DATA,
          payload: rows
        });
        } else {
        ToastMessage(ERROR, data.data.message);
        dispatch(closeLoader());
      }
    } catch (error) {
      console.log("Error message",error)
      ToastMessage(ERROR, error);
      dispatch(closeLoader());
    }
};



export const resetPaymentsData = (payload) => async (dispatch) => {
    dispatch({
      type: RESET_PAYMENTS_DATA,
      payload: {
        totalStudents:[],
        paymentCompleted:[],
        paymentDue:[]
      }
    });
};





